import {
  ApiDeleteProductFromMyWishlistFailedAction,
  ApiDeleteProductFromMyWishlistSucceededAction,
  apiDeleteProductFromMyWishlistFailedType,
  apiDeleteProductFromMyWishlistRequested,
  apiDeleteProductFromMyWishlistSucceededType
} from '@spa/lib/store/api/wishlists/deleteProductFromMyWishlistApi';
import {
  DeleteProductFromMyWishlistRequestedAction,
  deleteProductFromMyWishlistFailed,
  deleteProductFromMyWishlistSucceeded
} from '@spa/lib/store/wishlists/wishlistsSlice';
import { EventType, trackWishlistsActions } from '@spa/lib/tracking/trackWishlistsActions';
import { call, put, select } from 'typed-redux-saga';
import generateActionId from '@spa/lib/generateActionId';
import selectPathname from '@spa/lib/store/router/selectors/selectPathname';
import waitForSucceededOrFailedAction from '@spa/lib/store/sagas/session/waitForSucceededOrFailedAction';

function* deleteProductFromMyWishlistSaga({
  payload: { actionId: requestedActionId, input, isDefault, product }
}: DeleteProductFromMyWishlistRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(
    apiDeleteProductFromMyWishlistRequested({ actionId, input, parentActionId: requestedActionId })
  );

  const waitResult = yield* waitForSucceededOrFailedAction<
    typeof apiDeleteProductFromMyWishlistSucceededType,
    typeof apiDeleteProductFromMyWishlistFailedType,
    ApiDeleteProductFromMyWishlistSucceededAction,
    ApiDeleteProductFromMyWishlistFailedAction
  >(
    actionId,
    apiDeleteProductFromMyWishlistSucceededType,
    apiDeleteProductFromMyWishlistFailedType
  );

  if (waitResult.type === 'succeeded') {
    yield* put(
      deleteProductFromMyWishlistSucceeded({
        input: waitResult.action.payload.input,
        requestedActionId
      })
    );

    if (product !== undefined && isDefault !== undefined) {
      const pathname: string = yield* select(selectPathname);
      yield* call(trackWishlistsActions, EventType.REMOVE, product, isDefault, pathname);
    }
  } else {
    yield* put(
      deleteProductFromMyWishlistFailed({
        error: waitResult.action.payload.error,
        requestedActionId
      })
    );
  }
}

export default deleteProductFromMyWishlistSaga;
